/* eslint-disable */
export class Conf {

  //static idempiereUrl = "http://192.168.100.29:8070/""
  //static idempiereUrl = "http://192.168.100.12:8090/"

  //demo x cliente
  //static idempiereUrl = "http://192.168.60.100:8071/"

  //static idempiereUrl = "http://192.168.100.130:8071/"
  static idempiereUrl = "https://idempiere.vecositalia.it/"

  static windowTitle = 'CERTIFICO'
}
